// extracted by mini-css-extract-plugin
export default {"phoneInput":"CustomPhoneInput_phoneInput__p7B6L","phoneInput_input":"CustomPhoneInput_phoneInput_input__iRXfp","disabled":"CustomPhoneInput_disabled__FZdUU"};